// @flow
import * as React from 'react';
import styled from 'styled-components';
import SoundOn from 'assets/images/driving-zone/btn-index-sound-on.svg';
import SoundOff from 'assets/images/driving-zone/btn-index-sound-off.svg';
import {LayoutLeftBottom} from 'components/Layout';
import * as VideoUtils from 'utils/videoUtils';
import * as AudioUtils from 'utils/audioUtils';

type Props = {
  onClick?: () => void,
};



export default function SoundToggleButton(props: Props): React.Element<any> {
  const [sound, setSound] = React.useState(!VideoUtils.getMuted());
  return (
    <DivSoundButton>
      <button onClick={() => {

        let nextSound = !sound;
        setSound(nextSound);
        VideoUtils.setMuted(!nextSound);
        AudioUtils.updateMuted();
        if (props.onClick != null) {
          props.onClick();
        }

      }
      } ><img src={sound ? SoundOn : SoundOff} alt="" /></button>
    </DivSoundButton>
  );
}

const DivSoundButton = styled(LayoutLeftBottom)`
  button {
    width: ${props => props.theme.layout.mobile ? 25 + 60 : 32 + 160}px;
    height: ${props => props.theme.layout.mobile ? 22 + 70 : 28 + 128}px;
    padding: ${props => props.theme.layout.mobile ? 35 : 64}px ${props => props.theme.layout.mobile ? 30 : 80}px;
  }
`;
